import React, { ReactNode } from 'react';

/**
 * Base for the outline (stroke) icons that replaced the Lucide icon package (RES-7106).
 * Same drawing contract as Lucide: 24x24 viewBox, no fill, 2px round stroke in
 * `currentColor`, so Tailwind `size-*` / `text-*` classes and the `size` /
 * `color` props keep working exactly as before.
 *
 * Paths are taken from Lucide (https://lucide.dev), ISC licence,
 * Copyright (c) for portions of Lucide are held by Cole Bemis 2013-2022 as part of Feather (MIT).
 * All other copyright (c) for Lucide are held by Lucide Contributors 2022.
 */
export type StrokeIconProps = Omit<React.SVGProps<SVGSVGElement>, 'color' | 'strokeWidth'> & {
  size?: number;
  color?: string;
  strokeWidth?: number;
};

export default function StrokeIcon({
  size = 24,
  color = 'currentColor',
  strokeWidth = 2,
  className,
  children,
  ...rest
}: StrokeIconProps & { children: ReactNode }): JSX.Element {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      {...rest}
    >
      {children}
    </svg>
  );
}
